export enum TaxStaus {
    PRE = "PRE TAX",
    POST = "POST TAX",
}